import Vue from 'vue'
import VueRouter from 'vue-router'
import StartseiteCustomer from '@/views/home/index-customer'
import StartseiteFoodi from '@/views/home/index-foodi'
import StartseiteStrandbutler from '@/views/home/index-strandbutler'
import SeoPizza from '@/views/home/pizza'
import SeoBurger from '@/views/home/burger'
import SeoDoener from '@/views/home/doener'
import CouponRedemption from '@/views/home/coupon-redemption'
import Impressum from '@/views/imprint/index'
import Datenschutz from '@/views/privacy/index'
import Lieferorte from '@/views/locations/index'
import Lieferdienstauswahl from '@/views/locations/select'
import Oeffnungszeiten from '@/views/openinghours/index'
import Speisekarte from '@/views/menu/index'
import SpeisekarteRedirect from '@/views/menu/redirect'
import Warenkorb from '@/views/basket/index'
import PayPal from '@/views/paypal/redirect'
import Danke from '@/views/confirmation/done'
import DankeBuero from '@/views/confirmation/done-office'
import Generator from '@/views/generator/index'
import Buerobestellung from '@/views/officeorder/index'
import PageNotFound from '@/views/errors/404-not-found'
import Bewertungen from '@/views/review/index'
import Bewerten from '@/views/review/create'
import Archiv from '@/views/archive/index'
import Recommend from '@/views/recommend/index'
import Sofortueberweisung from '@/views/sofortueberweisung/redirect'
import Giropay from '@/views/giropay/redirect'
import Registration from '@/views/registration/index'
import Information from '@/views/information/index'
import Agb from '@/views/agb/index'
import AgbBusiness from '@/views/agb/business'
import Test from '@/views/test/index'
import User from '@/views/user/index'
import UserForgotPasswd from '@/views/user/forgotpasswd'
import UserRegistration from '@/views/user/registration'
import Business from '@/views/user/business'

Vue.use(VueRouter)

const routes = [
  {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: Datenschutz,
    meta: {
      title: 'Datenschutz'
    }
  },
  {
    path: '/lieferorte',
    name: 'Lieferorte',
    component: Lieferorte,
    meta: {
      title: 'Liefergebiet'
    }
  },
  {
    path: '/lieferdienste/:geoUrl',
    name: 'Lieferdienstauswahl',
    component: Lieferdienstauswahl,
    meta: {
      title: 'Lieferdienstauswahl'
    }
  },
  {
    path: '/anbieter/:geoUrl',
    name: 'Anbieter',
    component: Lieferdienstauswahl,
    meta: {
      title: 'Anbieter wählen'
    }
  },
  {
    path: '/oeffnungszeiten',
    name: 'Oeffnungszeiten',
    component: Oeffnungszeiten,
    meta: {
      title: 'Öffnungszeiten'
    }
  },
  {
    path: '/speisekarte/:hostUrl',
    name: 'Speisekarte',
    component: Speisekarte,
    meta: {
      title: 'Speisekarte'
    }
  },
  {
    path: '/shop/:hostUrl/table|:tableId|:tableToken',
    name: 'Tischbestellung',
    component: Speisekarte,
    meta: {
      title: 'Tischbestellung'
    }
  },
  {
    path: '/shop/:hostUrl/table%7C:tableId%7C:tableToken',
    name: 'Tischbestellung',
    component: Speisekarte,
    meta: {
      title: 'Tischbestellung'
    }
  },
  {
    path: '/shop/:hostUrl',
    name: 'Shop',
    component: Speisekarte,
    meta: {
      title: 'Speisekarte'
    }
  },
  {
    path: '/speisekarte',
    name: 'SpeisekarteRedirect',
    component: SpeisekarteRedirect,
    meta: {
      title: 'Speisekarte'
    }
  },
  {
    path: '/warenkorb/:hostUrl',
    name: 'Warenkorb',
    component: Warenkorb,
    meta: {
      title: 'Warenkorb'
    }
  },
  {
    path: '/paypal/:orderId',
    name: 'PayPal',
    component: PayPal,
    meta: {
      title: 'Bitte warten'
    }
  },
  {
    path: '/sofortueberweisung/:orderId',
    name: 'Sofortueberweisung',
    component: Sofortueberweisung,
    meta: {
      title: 'Bitte warten'
    }
  },
  {
    path: '/giropay',
    name: 'Giropay',
    component: Giropay,
    meta: {
      title: 'Bitte warten'
    }
  },
  {
    path: '/danke',
    name: 'Danke',
    component: Danke,
    meta: {
      title: 'Vielen Dank'
    }
  },
  {
    path: '/dankeBuero',
    name: 'DankeBuero',
    component: DankeBuero,
    meta: {
      title: 'Vielen Dank für deine Gruppenbestellung'
    }
  },
  {
    path: '/generator/:hostUrl/:id',
    name: 'Generator',
    component: Generator,
    meta: {
      title: 'Zutaten bearbeiten'
    }
  },
  {
    path: '/mitbestellen/:officeId/:officeUid',
    name: 'Buerobestellung',
    component: Buerobestellung,
    meta: {
      title: 'Gruppenbestellung'
    }
  },
  {
    path: '/bewertungen/:hostUrl',
    name: 'Bewertungen',
    component: Bewertungen,
    meta: {
      title: 'Kundenbewertungen'
    }
  },
  {
    path: '/archiv',
    name: 'Archiv',
    component: Archiv,
    meta: {
      title: 'Bestellhistorie'
    }
  },
  {
    path: '/bewerten/:orderId/:checksum',
    name: 'Bewerten',
    component: Bewerten,
    meta: {
      title: 'Bestellung bewerten'
    }
  },
  {
    path: '/empfehlen',
    name: 'Recommend',
    component: Recommend,
    props: {
      mode: 'recommend'
    },
    meta: {
      title: 'Lieferdienst empfehlen'
    }
  },
  {
    path: '/teilnehmen',
    name: 'Registration',
    component: Registration,
    props: {
      mode: 'register'
    },
    meta: {
      title: 'Lieferdienst anmelden'
    }
  },
  {
    path: '/teilnehmen/:hash/:id',
    name: 'RegistrationByQr',
    component: Registration,
    props: {
      mode: 'register'
    },
    meta: {
      title: 'Lieferdienst anmelden'
    }
  },
  {
    path: '/agb',
    name: 'Agb',
    component: Agb,
    meta: {
      title: 'Allgemeine Geschäftsbedingungen für Besteller'
    }
  },
  {
    path: '/agb/anbieter',
    name: 'AgbBusiness',
    component: AgbBusiness,
    meta: {
      title: 'Allgemeine Geschäftsbedingungen für Anbieter'
    }
  },
  {
    path: '/informationen',
    name: 'Informationen',
    component: Information,
    meta: {
      title: 'Informationen für Anbieter'
    }
  },
  {
    path: '/einstellungen',
    name: 'Einstellungen',
    component: User,
    meta: {
      title: 'Benutzereinstellungen'
    }
  },
  {
    path: '/business',
    name: 'Business',
    component: Business,
    meta: {
      title: 'Angebote für Geschäftskunden'
    }
  },
  {
    path: '/passwort',
    name: 'Passwort',
    component: UserForgotPasswd,
    meta: {
      title: 'Passwort zurücksetzen'
    }
  },

  {
    path: '/registrierung',
    name: 'Registrierung',
    component: UserRegistration,
    meta: {
      title: 'Registrierung'
    }
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {
      title: '404 Seite nicht gefunden'
    }
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: Impressum,
    meta: {
      title: 'Impressum'
    }
  }
]

if (window.type === 'customer') {
  routes.push({
    path: '/',
    name: 'Startseite',
    component: StartseiteCustomer
  })

  routes.push()
} else if (window.type === 'insite') {
  routes.push({
    path: '/',
    name: 'SpeisekarteRedirect',
    component: SpeisekarteRedirect,
    meta: {
      title: 'Speisekarte'
    }
  })
} else if (window.type === 'pos') {
  routes.push({
    path: '/',
    name: 'SpeisekarteRedirect',
    component: SpeisekarteRedirect,
    meta: {
      title: 'Speisekarte'
    }
  })
} else if (window.type === 'strandbutler') {
  routes.push({
    path: '/',
    name: 'Startseite',
    component: StartseiteStrandbutler
  })
} else {
  routes.push({
    path: '/',
    name: 'Startseite',
    component: StartseiteFoodi
  })

  routes.push({
    path: '/pizza',
    name: 'Pizza',
    component: SeoPizza,
    meta: {
      title: 'Pizza bestellen'
    }
  })

  routes.push({
    path: '/burger',
    name: 'Burger',
    component: SeoBurger,
    meta: {
      title: 'Burger bestellen'
    }
  })

  routes.push({
    path: '/doener',
    name: 'Doener',
    component: SeoDoener,
    meta: {
      title: 'Döner bestellen'
    }
  })

  routes.push({
    path: '/coupon/:code',
    name: 'Coupon',
    component: CouponRedemption,
    meta: {
      title: 'Gutschein einlösen'
    }
  })
}

routes.push({
  path: '/test',
  name: 'Test',
  component: Test,
  meta: {
    title: 'Test'
  }
})

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  document.title = (typeof to.meta.title === 'undefined' ? '' : to.meta.title + ' • ') + window.baseTitle

  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js